import { useEffect, useState } from "react";
import api from "../api";

const MOIS = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
  "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
const JOURS_SEMAINE = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];

const monthKey = (iso) => iso.slice(0, 7);

export const CycleCalendar = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/calendar/full").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data) return null;

  const byDate = {};
  data.past.forEach((s) => { byDate[s.date] = { ...s, done: true }; });
  data.future.forEach((s) => { if (!byDate[s.date]) byDate[s.date] = { ...s, done: false }; });

  const allDates = [...data.past.map((s) => s.date), ...data.future.map((s) => s.date), data.today];
  const months = [...new Set(allDates.map(monthKey))].sort();

  return (
    <section data-testid="full-calendar">
      <div className="bg-[#14141A] border border-[#2E2E3A] p-3 text-xs text-[#B0B0B4] mb-3 flex flex-wrap gap-x-4 gap-y-1">
        <span className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 bg-[#32D74B]/80 inline-block" /> Séance faite</span>
        <span className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 border border-[#FF3B30] inline-block" /> Séance à venir (projection 1/jour)</span>
        <span className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 border border-white/40 inline-block" /> Aujourd'hui</span>
      </div>
      <div className="space-y-4">
        {months.map((m) => {
          const [y, mo] = m.split("-").map(Number);
          const first = new Date(y, mo - 1, 1);
          const nbDays = new Date(y, mo, 0).getDate();
          const offset = (first.getDay() + 6) % 7;
          const cells = [...Array(offset).fill(null), ...Array.from({ length: nbDays }, (_, i) => i + 1)];
          return (
            <div key={m} data-testid={`calendar-month-${m}`}>
              <h3 className="font-display text-xl text-white mb-1.5">{MOIS[mo - 1].toUpperCase()} {y}</h3>
              <div className="grid grid-cols-7 gap-px bg-white/10 border border-[#2E2E3A]">
                {JOURS_SEMAINE.map((j) => (
                  <div key={j} className="bg-[#0A0A0A] text-center text-[9px] text-[#B0B0B4] py-1 uppercase">{j.charAt(0)}</div>
                ))}
                {cells.map((day, i) => {
                  if (!day) return <div key={`${m}-vide-${i}`} className="bg-[#0A0A0A] min-h-[46px]" />;
                  const iso = `${m}-${String(day).padStart(2, "0")}`;
                  const s = byDate[iso];
                  const isToday = iso === data.today;
                  return (
                    <div key={iso} data-testid={s ? `calendar-day-${iso}` : undefined}
                      className={`min-h-[46px] p-1 text-center ${
                        s ? (s.done ? "bg-[#32D74B]/15" : "bg-[#FF3B30]/10") : "bg-[#14141A]"} ${
                        isToday ? "outline outline-1 outline-white/50 -outline-offset-1" : ""}`}>
                      <p className={`text-[10px] font-mono ${isToday ? "text-white font-bold" : "text-[#B0B0B4]"}`}>{day}</p>
                      {s && (
                        <>
                          <p className={`text-[9px] font-bold leading-tight ${s.done ? "text-[#32D74B]" : "text-[#FF3B30]"}`}>
                            {s.bloc}·J{s.jour.slice(-1)}
                          </p>
                          <p className="text-[7px] text-[#B0B0B4] leading-tight truncate">{s.contenu.split(" · ")[0]}</p>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
